import React, { FC } from 'react'

import { Icon3gProps } from './Icon3g.types'
import * as Styled from './styles/Icon3g.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon3g: FC<Icon3gProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon3gProps['size'],
  isResponsive = false,
}: Icon3gProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M16.665 22.848c.315-.064.636-.096.957-.098 2.428 0 4.395 1.685 4.395 3.765 0 1.587-1.25 3.54-3.89 3.54-2.25 0-3.427-1.117-3.887-2.1m-.258-9.97h7.533l-4.863 4.865M30.5 24.485H34v3a2.388 2.388 0 0 1-1.75 2.375c-2.07.565-6.25.933-6.25-5.875 0-7.375 6.64-6.473 7.625-4.625'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M43 24A19 19 0 1 1 24 5h19v19Z' stroke='#0D0D0D' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default Icon3g
